import { render } from "./entity_compliance_answers.html?vue&type=template&id=1b895611&scoped=true&external"
import script from "./entity_compliance_answers.js?vue&type=script&lang=js&external"
export * from "./entity_compliance_answers.js?vue&type=script&lang=js&external"

import "./EntityComplianceAnswers.vue?vue&type=style&index=0&id=1b895611&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b895611"]])

export default __exports__